import { Api } from '../api';
import { accounts } from '../endpoints';
import type {
  AccountDetailsEntity,
  AccountEntity,
  ChangeCreditLimitResponse,
  CreditChangeParams,
  CreditLimitEntity,
  GetCreditPdfRequest,
  RequestEntity,
  SetAccountPartnerAccountNumberRequest,
  UploadCreditFormRequest,
} from './models';

export class AccountApi extends Api {
  static getAccountsByCustomer = (customerId: string, signal?: AbortSignal) =>
    this.get<AccountEntity[]>(accounts.getCustomer(customerId), { signal });

  static getAccountDetails = (accountCode: string, signal?: AbortSignal) =>
    this.get<AccountDetailsEntity>(accounts.getAccountDetails(accountCode), { signal });

  static getCreditLimit = (accountId: string, signal?: AbortSignal) => this.get<CreditLimitEntity>(accounts.getCreditLimit(accountId), { signal });

  static changeCreditLimit = (searchParams: CreditChangeParams, signal?: AbortSignal) =>
    this.post<ChangeCreditLimitResponse>(accounts.postCreditLimit(), searchParams, { signal });

  static getCreditLimitRequests = (accountId: string, signal?: AbortSignal) =>
    this.get<RequestEntity[]>(accounts.getCreditLimitRequests(accountId), { signal });

  static approveRequest = (requestId: string, signal?: AbortSignal) =>
    this.post(accounts.approveCreditLimitRequest(requestId), { responseType: 'none', signal });

  static rejectRequest = (requestId: string, signal?: AbortSignal) =>
    this.post(accounts.rejectCreditLimitRequest(requestId), { responseType: 'none', signal });

  static setPartnerAccountNumber = (request: SetAccountPartnerAccountNumberRequest, signal?: AbortSignal) =>
    this.post<SetAccountPartnerAccountNumberRequest>(accounts.partnerAccountNumber(), request, { responseType: 'none', signal });

  static getUploadedCreditPdf = (requestId: string, signal?: AbortSignal) =>
    this.get<Blob>(accounts.getCreditLimitFile(requestId), { headers: { Accept: 'application/pdf' }, responseType: 'blob', signal });

  static uploadCreditForm = (request: UploadCreditFormRequest, signal?: AbortSignal) => {
    const formData = request.data.reduce((curData, file) => {
      curData.append('file', file);

      return curData;
    }, new FormData());

    return this.post<FormData>(accounts.uploadCreditLimitFile(request.requestId), formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      signal,
    });
  };

  static getCreditPdf = (queryParams: GetCreditPdfRequest, signal?: AbortSignal) =>
    this.get<Blob>(accounts.getCreditPdf(), { queryParams, headers: { Accept: 'application/pdf' }, responseType: 'blob', signal });
}
